import React from 'react';
import { ReactComponent as Abstract } from 'assets/img/vectors/Upward_Loader.svg';
import PropTypes from 'prop-types';

const UpwardLoaderVector = (props) => {
  return (
     <div style={{ width: `${ props.size }px`, height: `${ props.size }px` }} className='position-relative'>
        <Abstract />
     </div>
  )
};

UpwardLoaderVector.propTypes = {
   size: PropTypes.number,
};

UpwardLoaderVector.defaultProps = {
   size: 120,
};

export default UpwardLoaderVector;
